import React, { useState, useEffect } from 'react'
import { Box, Heading, Text, Grid } from "@chakra-ui/react";
import { FaSchool, FaGraduationCap, FaBriefcase, FaPalette } from "react-icons/fa";
import { SelectionCard } from '../SelectionCard';
import { useStore } from "../../Store";
import { SelectAudienceSkeleton } from '../SelectAudienceSkeleton';

const obj = {
  'PK-12': { icon: FaSchool, title: 'K12', description: 'Primary and secondary education content for students aged 5-18', tags: ['Elementary', 'Middle School', 'High School'] },
  'Professional': { icon: FaBriefcase, title: 'Professional', description: 'Career development and professional training materials', tags: ['Corporate', 'Certification', 'Skills'] },
  'HigherEd': { icon: FaGraduationCap, title: 'Higher Education', description: 'College and university level educational content', tags: ['Undergraduate', 'Graduate', 'Research'] },
  'Hobby': { icon: FaPalette, title: 'Hobby', description: 'Recreational and personal interest learning content', tags: ['Art', 'Craft', 'Cooking', 'Music'] },
}
export const SelectAudience = ({ dynoCategories, product, type }) => {

  const [loading, setLoading] = useState(true)
  const {updateStates} = useStore((state) => state);
  const categories = dynoCategories.filter(dc => dc.name !== "General").map(dc => ({
    ...dc,
    ...obj[dc.name]
  }))

  useEffect(() => {
    if(dynoCategories.length > 0) {
      setLoading(false)
    }
  }, [dynoCategories])

  return (
      loading ?
      <SelectAudienceSkeleton /> :
      <Box w="100%">
        <Heading as='h3' size='lg' mb={4}>Choose Your Audience</Heading>
        <Text fontSize="md" mb={8} color="gray.600">Select the target audience for your educational content</Text>

        <Grid templateColumns="repeat(2, 1fr)" gap={3}>
          {categories?.map((categry) => (
            <SelectionCard
              key={categry.id}
              category={categry}
              isSelected={product.category.id === categry.id}
              onSelect={() =>  updateStates({
                  [type]: {...product, category: categry}
                })
              }
            />
          ))}
        </Grid>
      </Box>
  )
}
